module.exports = __webpack_public_path__ + "static/media/popular-game2.cac38676.png";